import antdEn from "antd/lib/locale/en_GB";
import appLocaleData from "react-intl/locale-data/en";
import enMessages from "../locales/en.json";

const EnLang = {
  messages: {
    ...enMessages
  },
  antd: antdEn,
  locale: 'en-gb',
  data: appLocaleData
};
export default EnLang;
